import { apiClient } from '../../lib/api-client';
import type { BedBooking, BedBookingPayload, BedStatusResponse } from './types';

export const fetchBedStatus = async (search: string) => {
  const response = await apiClient.get<BedStatusResponse>('/bed-status', {
    params: search ? { search } : undefined,
  });
  return response.data.data;
};

export const createBedBooking = async (bedId: string, payload: BedBookingPayload) => {
  const response = await apiClient.post<{ success: true; data: BedBooking }>(`/bed-status/${bedId}/bookings`, payload);
  return response.data.data;
};
